import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDataAPI, postDataAPI, putDataAPI } from "../../utils/FetchData";
import { setErrorAlert, setLoader, setSuccessAlert } from "../alert/alertSlice";
import { get_folder_thunk } from "../folder/folderThunk";
import { sync_data_thunk } from "../auth/authThunk";

export const create_todo_thunk = createAsyncThunk('user/todo/create_todo', async (tempData, thunkAPI) => {
    try {

        let body = {
            id: tempData?.data?.id,
            text: tempData?.data?.text,
            completed: tempData?.data?.completed,
            fileId: tempData?.data?.fileId,
            // todoOrder: tempData?.data?.todoOrder
        }
        await postDataAPI('user/todo/create_todo', body, tempData.token);
        return
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})
export const get_todo_thunk = createAsyncThunk('user/todo/get_todos', async (tempData, thunkAPI) => {
    try {

        const response = await getDataAPI('user/todo/get_todos', tempData.token);
        localStorage.setItem(`todos`, JSON.stringify(response.data.data.response));
        return response.data
    } catch (error) {
        console.log('error', error)
        // thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'Your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})
export const edit_todo_thunk = createAsyncThunk('user/todo/update_todo', async (tempData, thunkAPI) => {
    try {

        let body = {
            id: tempData?.data?.descId,
            text: tempData?.data?.text,
            completed: tempData?.data?.completed,
        }
        await putDataAPI('user/todo/update_todo', body, tempData.token);
        return
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})
export const update_todo_priority_thunk = createAsyncThunk('user/todo/update_todo_priorities', async (tempData, thunkAPI) => {
    try {

        let body = {
            updates: tempData?.updates
        }
        await putDataAPI('user/todo/update_todo_priorities', body, tempData.token);
        return
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})

export const delete_todo_thunk = createAsyncThunk('user/todo/delete_todos', async (tempData, thunkAPI) => {
    try {

        let body = {
            ids: tempData?.descIds,
            deleted: tempData?.deleted
        }
        await putDataAPI('user/todo/delete_todos', body, tempData.token);
        return
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(
            get_folder_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(
            get_todo_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})

export const create_or_update_todo_order = createAsyncThunk('user/order/create_or_update_todo_order', async (tempData, thunkAPI) => {
    try {
        await putDataAPI('user/order/create_or_update_todo_order', tempData.data, tempData.token);
        return
    } catch (error) {
        console.log('error', error)

        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})
export const get_todo_order = createAsyncThunk(
    'user/order/get_todo_order',
    async (tempData, thunkAPI) => {
        try {
            const response = await getDataAPI('user/order/get_todo_order', tempData.token);
            
            // Extract the array of todo orders from the response
            const todoOrdersArray = response.data?.data?.response || [];
            
            // Transform array of todo orders into an object with fileId as keys
            const todoOrders = todoOrdersArray.reduce((acc, item) => {
                if (item?.fileId && Array.isArray(item?.todoOrder)) {
                    acc[item.fileId] = item.todoOrder;
                }
                return acc;
            }, {});

            // Store in localStorage
        

            return todoOrders;
        } catch (error) {
            console.error('Error fetching todo orders:', error);
            const errorMessage = error?.response?.data?.message || 
                'The data is not stored because your network is offline';
            thunkAPI.dispatch(setErrorAlert(errorMessage));
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);